// Metadata-only registry. Importable from Node (build scripts) without
// pulling in JSX/React. Keep in sync with the article modules.
//
// Used by scripts/prerender-articles.ts to generate per-article
// index.html files with proper og:* tags for social-preview crawlers
// (iMessage, Facebook, WhatsApp itp.) which do NOT execute JavaScript.
//
// Uwaga: og:image celowo NIE jest per-artykuł - wszystkie linki używają
// domyślnego loga z index.html (/og-image.jpg). Per artykuł zmienia się
// wyłącznie tytuł i opis (podpis).

export type ArticleMeta = {
  slug: string;
  title: string;
  description: string;
  publishedAt: string;
  category: string;
  excerpt: string;
};

export const articlesMeta: ArticleMeta[] = [
  {
    slug: "pies-i-kot-w-upal-jak-schlodzic",
    title: "Pies i kot w upał - jak schłodzić zwierzę w domu?",
    description:
      "Jak zadbać o psa i kota w upał? Sprawdź, kiedy wychodzić na spacer, jak schłodzić psa i kota w domu, jakie są objawy przegrzania i kiedy iść do weterynarza.",
    publishedAt: "2026-07-01",
    category: "Opieka",
    excerpt:
      "Krótkie spacery, chłodne płytki, mata do lizania i tacka z wodą dla kota - praktyczna lista kontrolna na upalne dni oraz objawy przegrzania, których nie wolno ignorować.",
  },
  {
    slug: "jak-wyglada-adopcja-psa-lub-kota-ze-schroniska",
    title: "Jak wygląda adopcja psa lub kota ze schroniska?",
    description:
      "Krok po kroku: ankieta, rozmowa, spotkanie ze zwierzakiem, wizyta przedadopcyjna i umowa. Jak naprawdę wygląda adopcja psa lub kota ze schroniska.",
    publishedAt: "2026-05-15",
    category: "Adopcja",
    excerpt:
      "Ankieta, rozmowa z fundacją, wizyta przedadopcyjna, umowa - jak naprawdę wygląda proces adopcji psa lub kota ze schroniska i czego się spodziewać krok po kroku.",
  },
  {
    slug: "jak-przygotowac-sie-do-adopcji-kota",
    title: "Jak przygotować się do adopcji kota?",
    description:
      "Praktyczny przewodnik dla osób adoptujących kota - co naprawdę warto kupić, jak przygotować mieszkanie i na co nie warto wydawać pieniędzy na początku.",
    publishedAt: "2026-05-14",
    category: "Adopcja",
    excerpt:
      'Co naprawdę warto kupić przed adopcją kota, a bez czego można się obejść? Praktyczny przewodnik po kuwetach, miskach, transporterach, karmie i drapakach - bez listy „niezbędnych" rzeczy z internetu.',
  },
];
